export default { sha: 'a908714501411eac36b268e977ef597ab12fb03b', buildNumber: 'undefined' }
